import { Helmet } from "react-helmet-async";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://sideb-app.com").replace(/\/$/, "");
export const SITE_NAME = "Side B";
const DEFAULT_TITLE = "Side B — Apprendre à investir, comprendre les marchés";
const DEFAULT_DESC =
  "Side B : analyses, cours, outils et portefeuilles suivis en direct pour apprendre à investir avec méthode.";
const DEFAULT_IMAGE = `${SITE_URL}/logo-sideb.png`;

function absUrl(u) {
  if (!u) return DEFAULT_IMAGE;
  if (/^https?:\/\//i.test(u)) return u;
  return `${SITE_URL}${u.startsWith("/") ? "" : "/"}${u}`;
}

/**
 * Balises SEO par page : <title>, meta description, URL canonique, Open Graph, Twitter Card
 * et données structurées JSON-LD. N'affiche rien visuellement.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  noindex = false,
  jsonLd = null,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const canonical = `${SITE_URL}${cleanPath}`;
  const img = absUrl(image);
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="fr_FR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
